import { useEffect } from 'react'
import { Reveal, Tween } from 'react-gsap'
import styled from 'styled-components'
import { CompanyCard } from '../../../../shared/components/companies/search/CompanyCard'
import CompanyPagination from '../../../../shared/components/companies/search/CompanyPagination'
import { CompaniesContentGrid } from '../../../../shared/styles/companies/companies'
import { Container, ContainerContentStandard } from '../../../../shared/styles/container'
import Layout from '../../components/global/Layout'
import Seo from '../../components/global/Seo'
import { BUCKET_URL } from '../../model/S3Bucket'
import { CompanyOperation, fetchCompaniesAsync, selectCompanies, selectCompaniesNextToken, selectCompaniesPrevTokens } from '../../redux/companiesSlice'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'

const CompaniesSearch = styled.article`
    padding-top: 32px;
    padding-bottom: 32px;
    min-height: 100vh;
    h1 {
        font-weight: 700;
        font-size: 36px;
        line-height: 49px;
        margin-top: 0;
        margin-bottom: 24px;
    }
`;

const CompaniesPage = () => {

    const dispatch = useAppDispatch()
    const companies = useAppSelector(selectCompanies)
    const nextToken = useAppSelector(selectCompaniesNextToken)
    const previousTokens = useAppSelector(selectCompaniesPrevTokens)

    const fetchData = async (token, operation) => {
        const variables = {};
        /*         variables['limit'] = 12; */
        variables['nextToken'] = token;
        variables['operation'] = operation;
        await dispatch(fetchCompaniesAsync(variables))
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        if (companies == null) {
            fetchData(null, CompanyOperation.INITIAL);
        }

    }, [dispatch, companies])

    const pageBack = () => {
        fetchData(previousTokens[previousTokens.length - 1], CompanyOperation.PREV).then(() => {
            if (typeof window != 'undefined') {
                window.scrollTo(0, 0)
            }
        });

    }

    const pageNext = () => {
        fetchData(nextToken, CompanyOperation.NEXT).then(() => {
            if (typeof window != 'undefined') {
                window.scrollTo(0, 0)
            }
        });
    }
    const title = 'Unternehmen entdecken | STELL-MICH-EIN';
    const description = 'Entdecke die Unternehmen vom STELL-MICH-EIN';

    return (
        <>
            <Seo title={title} description={description} />
            <Layout preview={false}>
                <Container backgroundColor='#f5f5f7'>
                    <ContainerContentStandard>
                        <CompaniesSearch>
                            <h1>Unternehmen entdecken</h1>
                            {companies != null && companies?.length > 0 &&
                                <>
                                    <Reveal>
                                        <Tween
                                            from={{ y: 50, opacity: 0 }}
                                            to={{ y: 0, opacity: 1 }}
                                            duration={1}
                                            stagger={{ from: 'start', amount: 1 }}
                                            wrapper={<CompaniesContentGrid />}
                                        >
                                            {companies?.map((company, index) => {
                                                return (
                                                    <li key={company.name + index}>
                                                        <CompanyCard company={company} index={index} bucketUrl={BUCKET_URL} />
                                                    </li>
                                                )
                                            })}
                                        </Tween>
                                    </Reveal>
                                    <CompanyPagination
                                        prevDisabled={previousTokens?.length < 1}
                                        nextDisabled={nextToken == null}
                                        pageBack={() => pageBack()}
                                        pageNext={() => pageNext()}
                                    />
                                </>
                            }
                        </CompaniesSearch>
                    </ContainerContentStandard>
                </Container>
            </Layout>
        </>
    )
}

export default CompaniesPage;

/* export async function getServerSideProps(context) {
    const { req: { headers, url }, res } = context;
    return {
        props: {
            //agentur
        },
    };
} */
